import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from "../../dashboard/com/border";
import analysis from "../../dashboard/com/analysis";
import { querySiteList, queryWastehydrologyCurveAnalysis } from '@/api/api';
import moment from 'moment';
import { getAction } from '@/api/manage';
import tideAnalysis from "../../dashboard/com/tideAnalysis";
import fileTable from "../../dashboard/com/fileTable";
export default {
  name: 'waterRegime',
  components: {
    border: border,
    analysis: analysis,
    tideAnalysis: tideAnalysis,
    fileTable: fileTable
  },
  data: function data() {
    return {
      selectedTabId: '',
      showFileTable: false,
      tabList: [],
      radio: '',
      radioOptions: [],
      radio1: '',
      radioOptions1: [],
      moment: moment,
      showAnalysis: false,
      showTideAnalysis: false,
      showTideAnalysis1: false,
      selectType: 2,
      selectTab: [],
      riverDate: [],
      dateList: [],
      realRainyArr: [],
      markerList: [],
      tagList: [{
        type: 1,
        title: '水库',
        show: true,
        icon: 'icon-shuiyuqingjiancedian',
        siteList: []
      }, {
        type: 2,
        title: '泵站',
        show: true,
        icon: 'icon-bengzhan1',
        siteList: []
      }, {
        type: 3,
        title: '闸站',
        show: true,
        icon: 'icon-dazhongxingshuizha-map',
        siteList: []
      }, {
        type: 4,
        title: '位移',
        show: true,
        icon: 'icon-tangyanbagongcheng',
        siteList: []
      }, {
        type: 5,
        title: '渗压',
        show: true,
        icon: 'icon-yali',
        siteList: []
      }, {
        type: 6,
        title: '渗流',
        show: true,
        icon: 'icon-liuliang1',
        siteList: []
      }]
    };
  },
  mounted: function mounted() {
    this.getMarkerData();
  },
  watch: {
    radio: function radio() {
      this.showTide();
    },
    radio1: function radio1() {
      this.showTide('1');
    }
  },
  methods: {
    getSiteTab: function getSiteTab(siteTab) {
      var _this = this;

      siteTab.forEach(function (item) {
        item.id = item.type;

        if (item.type < 4) {
          _this.tabList.push(item);
        }
      });
      this.onToSelectedTab({
        id: ''
      });
    },
    onToSelectedTab: function onToSelectedTab(item) {
      if (item.id === this.selectedTabId) {
        item = {
          type: '',
          id: ''
        };
      }

      this.selectedTabId = item.id;
      this.showDateList(item);
    },
    getMarkerData: function getMarkerData() {
      var _this2 = this;

      querySiteList({
        // st: 60,
        field: 'id,,mn,name,departName,tenantName,userId_userName,riverName,areaName,status_dictText,action',
        current: 1,
        size: -1,
        searchCount: true
      }).then(function (res) {
        console.log('res', res);

        if (res.success) {
          res.result.records.forEach(function (item) {
            if (item.st == 61) {
              var type = _this2.handleType(item);

              item.type = type;

              _this2.markerList.push(_objectSpread({}, item));
            }
          });

          _this2.getSiteData(_this2.markerList);

          _this2.getSiteTab(_this2.tagList);
        }
      });
    },
    handleType: function handleType(item) {
      if (item.st == 61) {
        return 1;
      } else {
        return item.category - 0;
      }
    },
    getSiteData: function getSiteData(siteArr) {
      var _this3 = this;

      console.log('siteArr', siteArr);
      siteArr = siteArr.filter(function (item) {
        return item.st == 61;
      });
      this.site = siteArr;
      this.dateList = [];
      var siteArrs = [];
      this.siteData = this.site.filter(function (item) {
        return item.type < 4;
      });
      this.siteData.forEach(function (item) {
        siteArrs.push(item.id);
      });
      var param = {
        stime: moment().format('YYYY-MM-DD'),
        etime: moment().format('YYYY-MM-DD'),
        quantum: siteArrs.join(','),
        type: 7,
        column: 'data_time',
        order: 'asc',
        dataType: 11
      };
      this.resData = [];
      this.radioOptions = [];
      this.factorMap = {};
      queryWastehydrologyCurveAnalysis(param).then(function (res) {
        if (res.success) {
          _this3.resData = res.result.records;
        }

        _this3.showRealRainy(); //实时降雨


        _this3.showTide();
      });
      this.getSiteFlow();
    },
    showRealRainy: function showRealRainy() {
      var _this4 = this;

      var time = [];
      var labelData = [];
      var popArr = [];
      var arr = [];
      this.siteData.forEach(function (item) {
        labelData.push(item.name);
        popArr.push({
          data: [],
          title: item.name
        });
      });
      this.siteData.forEach(function (ele, index) {
        _this4.resData.forEach(function (item) {
          arr.push({
            name: item.dataTime,
            value: item.data[ele.id] && item.data[ele.id].hasOwnProperty('sl021') && item.data[ele.id]['sl021'] !== null && item.data[ele.id]['sl021'] !== '' ? item.data[ele.id]['sl021'] : ''
          });
        });

        popArr[index].data = arr;
        arr = [];
      });
      this.resData.forEach(function (item) {
        time.push(item.dataTime);
      });
      this.showAnalysis = false;
      this.$nextTick(function () {
        _this4.showAnalysis = true;

        _this4.$nextTick(function () {
          _this4.$refs.pollution.initBarChart(popArr, time, labelData, undefined, 3, '降雨量(mm)');
        });
      });
    },
    getSiteFlow: function getSiteFlow() {
      var _this5 = this;

      var arr = [];
      var site = [403, 404];
      var site1 = [];
      this.siteData.forEach(function (item) {
        if (site.findIndex(function (data) {
          return data === item.id;
        }) == -1) {
          site1.push(item.id);
        }
      });
      arr.push(this.getSiteFlowApi(site));
      arr.push(this.getSiteFlowApi(site1));
      Promise.all(arr).then(function (data) {
        _this5.handleRadioData(data[0], site, '');

        _this5.handleRadioData(data[1], site1, '1');
      });
    },
    handleRadioData: function handleRadioData(res, site, str) {
      var _this6 = this;

      this['factorMap' + str] = {};
      this['resDataWater' + str] = res.result.records;
      this['radioOptions' + str] = [];
      res.result.query.factors.forEach(function (item) {
        var factorObj = item;
        item.factorObj = {};

        _this6.siteData.filter(function (item) {
          return site.indexOf(item.id) > -1;
        }).forEach(function (item1) {
          var obj = JSON.parse(JSON.stringify(item1));
          obj.factor = JSON.parse(JSON.stringify(item));
          obj.arr = [];
          res.result.records.forEach(function (item2) {
            obj.arr.push(item2.data && item2.data[item1.id] && item2.data[item1.id].hasOwnProperty(item.code) && item2.data[item1.id][item.code] !== null && item2.data[item1.id][item.code] !== '' ? item2.data[item1.id][item.code] : '');
          });
          item.factorObj[item1.id] = obj;
        });

        _this6['factorMap' + str][item.code] = factorObj;

        if (item.code != 'sl021') {
          _this6['radioOptions' + str].push(item);
        }
      });
      this['radio' + str] = this['radioOptions' + str].length > 0 ? this['radioOptions' + str][0].code : '';
    },
    getSiteFlowApi: function getSiteFlowApi(siteArrs) {
      var param = {
        stime: moment().format('YYYY-MM-DD'),
        etime: moment().format('YYYY-MM-DD'),
        quantum: siteArrs.join(','),
        type: 7,
        column: 'data_time',
        order: 'asc',
        dataType: 11
      };
      return new Promise(function (resolve, reject) {
        queryWastehydrologyCurveAnalysis(param).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    showTide: function showTide() {
      var _this7 = this;

      var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var xAxisData = [];
      var yAxisData = [];
      this['resDataWater' + str].forEach(function (item) {
        xAxisData.push(item.dataTime);
      });
      var factorMap = this['factorMap' + str];
      var radio = this['radio' + str];

      for (var i in factorMap[radio].factorObj) {
        yAxisData.push({
          title: factorMap[radio].factorObj[i].name,
          data: factorMap[radio].factorObj[i].arr
        });
      }

      this['showTideAnalysis' + str] = false;
      this.$nextTick(function () {
        _this7['showTideAnalysis' + str] = true;

        _this7.$nextTick(function () {
          _this7.$refs['tideAnalysisRef' + str].initBarChart(xAxisData, yAxisData, "".concat(factorMap[radio].title, "(").concat(factorMap[radio].unitName, ")"));
        });
      });
    },
    showDateList: function showDateList(data) {
      var _this8 = this;

      if (this.selectedTabId == 1) {
        this.column = [{
          label: '站点',
          code: 'siteName'
        }, {
          label: '时间',
          code: 'dataTime'
        }, {
          label: '水位(m)',
          code: 'sl011'
        }, {
          label: '降雨量(mm)',
          code: 'sl021'
        }];
      } else {
        this.column = [{
          label: '站点',
          code: 'siteName'
        }, {
          label: '时间',
          code: 'dataTime'
        }, {
          label: '水位(m)',
          code: 'sl011'
        }, {
          label: '流速(m/s)',
          code: 'sl012'
        }, {
          label: '降雨量(mm)',
          code: 'sl021'
        }];
      }

      this.dateList = [];
      getAction("/online/st61/siteWaterAndRain", {
        category: data.type
      }).then(function (res) {
        if (res.success) {
          _this8.showFileTable = false;

          _this8.$nextTick(function () {
            _this8.showFileTable = true;

            _this8.$nextTick(function () {
              _this8.dateList = res.result;
            });
          });
        }
      });
    },
    showRiverDate: function showRiverDate() {
      var _this9 = this;

      this.riverDate = [];
      this.site.forEach(function (item, index) {
        if (item.name.indexOf('泵站') > -1 || item.name.indexOf('闸站') > -1) {
          _this9.riverDate.push({
            site: item.name,
            dateTime: "".concat(moment().format('YYYY-MM-DD'), " 07:").concat(index, ":00"),
            riverNum: (2.5 + index * 0.02).toFixed(2)
          });
        }
      });
    }
  }
};